<!------
  @description 组件/插件 的描述(描述 组件/插件 的作用)
  @methods 组件/插件 暴露出来的方法 变量
  @param 参数、约定的特殊标识
  @special 复杂组件实现，需特殊标明的业务逻辑
------>
<template>
  <div>
      筛选组件
  </div>
</template>

<script>
export default {
  name: 'screen',
  data () {
    return {

    }
  },
  computed: {},
  created () {

  },
  methods: {

  }
}
</script>

<style scoped lang='scss'>

</style>
